import CookieBasedCommands from "./utils/cookie-based-commands";
import { command_definitions } from "./utils/cookie_based_command_definitions";

window.CookieBasedCommands = CookieBasedCommands;
window.command_definitions = command_definitions;
